import { EventShort } from '@/types/Event.type'

export function participatedEvents(state: any): Array<EventShort[]> {
    if (!state.memberSingle?.memberEvents) {
        return []
    }

    return [...(state.memberSingle?.memberEvents.next || []), ...(state.memberSingle?.memberEvents.past || [])]
}
